import React from "react";
import {
  Box,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TextField,
  IconButton
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import { sdmTableStyles, getHeaderCellStyle } from "./sdmTableStyles";

const OfferedDepositsTable = ({ data, onChange }) => {
  const rows = data || [];

  const handleCellChange = (rowIndex, field, value) => {
    const updatedRows = rows.map((row, index) => {
      if (index === rowIndex) {
        return { ...row, [field]: value };
      }
      return row;
    });
    onChange(updatedRows);
  };

  const handleAddRow = () => {
    const newRow = {
      title: "",
      owner: "",
      date: "",
      independentAssessment: "",
      insurance: "",
      existingEncumbrances: "",
      depositCheck: ""
    };
    onChange([...rows, newRow]);
  };

  const handleDeleteRow = (rowIndex) => {
    const updatedRows = rows.filter((_, index) => index !== rowIndex);
    onChange(updatedRows);
  };

  const columns = [
    { label: "Описание залога, месторасположение, занимаемая площадь", minWidth: 250 },
    { label: "Собственник залога", minWidth: 150 },
    { label: "Год выпуска залога (срок годности)", minWidth: 130 },
    { label: "Независимая оценка (оценщик, дата оценки, стоимость)", minWidth: 250 },
    { label: "Страховка (страховщик, дата окончания страховки, сумма страховки, выгодоприобретатель)", minWidth: 250 },
    { label: "Существующие обременения", minWidth: 150 },
    { label: "Дата проверки залога банком, ФИО проверяющего, замечания", minWidth: 250 },
  ];

  return (
    <Box sx={sdmTableStyles.tableWrapper}>
      <Box sx={sdmTableStyles.headerSection}>
        <Box sx={sdmTableStyles.sectionTitle}>
          СДМ-БАНК. ПРЕДЛАГАЕМЫЕ ЗАЛОГИ (от большего к меньшему по сумме)
        </Box>
      </Box>

      <TableContainer
        component={Paper}
        elevation={0}
        sx={sdmTableStyles.tableContainer}
      >
        <Table size={sdmTableStyles.tableSize}>
          <TableHead>
            <TableRow sx={sdmTableStyles.headerRow}>
              {columns.map((headCell, index) => (
                <TableCell
                  key={index}
                  sx={getHeaderCellStyle(headCell.minWidth)}
                >
                  {headCell.label}
                </TableCell>
              ))}
              <TableCell sx={sdmTableStyles.emptyCell} />
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row, rowIndex) => (
              <TableRow key={rowIndex} sx={sdmTableStyles.dataRow}>
                <TableCell sx={sdmTableStyles.dataCell}>
                  <TextField
                    value={row.title || ""}
                    onChange={(e) => handleCellChange(rowIndex, 'title', e.target.value)}
                    variant="outlined"
                    size="small"
                    fullWidth
                    multiline
                    minRows={1}
                    sx={sdmTableStyles.textFieldMultiline}
                  />
                </TableCell>
                <TableCell sx={sdmTableStyles.dataCell}>
                  <TextField
                    value={row.owner || ""}
                    onChange={(e) => handleCellChange(rowIndex, 'owner', e.target.value)}
                    variant="outlined"
                    size="small"
                    fullWidth
                    multiline
                    minRows={1}
                    sx={sdmTableStyles.textFieldMultiline}
                  />
                </TableCell>
                <TableCell sx={sdmTableStyles.dataCell}>
                  <TextField
                    value={row.date || ""}
                    onChange={(e) => handleCellChange(rowIndex, 'date', e.target.value)}
                    variant="outlined"
                    size="small"
                    fullWidth
                    sx={sdmTableStyles.textField}
                  />
                </TableCell>
                <TableCell sx={sdmTableStyles.dataCell}>
                  <TextField
                    value={row.independentAssessment || ""}
                    onChange={(e) => handleCellChange(rowIndex, 'independentAssessment', e.target.value)}
                    variant="outlined"
                    size="small"
                    fullWidth
                    multiline
                    minRows={1}
                    sx={sdmTableStyles.textFieldMultiline}
                  />
                </TableCell>
                <TableCell sx={sdmTableStyles.dataCell}>
                  <TextField
                    value={row.insurance || ""}
                    onChange={(e) => handleCellChange(rowIndex, 'insurance', e.target.value)}
                    variant="outlined"
                    size="small"
                    fullWidth
                    multiline
                    minRows={1}
                    sx={sdmTableStyles.textFieldMultiline}
                  />
                </TableCell>
                <TableCell sx={sdmTableStyles.dataCell}>
                  <TextField
                    value={row.existingEncumbrances || ""}
                    onChange={(e) => handleCellChange(rowIndex, 'existingEncumbrances', e.target.value)}
                    variant="outlined"
                    size="small"
                    fullWidth
                    multiline
                    minRows={1}
                    sx={sdmTableStyles.textFieldMultiline}
                  />
                </TableCell>
                <TableCell sx={sdmTableStyles.dataCell}>
                  <TextField
                    value={row.depositCheck || ""}
                    onChange={(e) => handleCellChange(rowIndex, 'depositCheck', e.target.value)}
                    variant="outlined"
                    size="small"
                    fullWidth
                    multiline
                    minRows={1}
                    sx={sdmTableStyles.textFieldMultiline}
                  />
                </TableCell>
                <TableCell sx={sdmTableStyles.dataCell}>
                  <IconButton
                    size="small"
                    onClick={() => handleDeleteRow(rowIndex)}
                    sx={sdmTableStyles.deleteButton}
                  >
                    <DeleteIcon fontSize="small" />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
            <TableRow>
              <TableCell colSpan={8} sx={sdmTableStyles.addRowCell}>
                <Button
                  fullWidth
                  onClick={handleAddRow}
                  startIcon={<AddCircleIcon />}
                  sx={sdmTableStyles.addRowButton}
                >
                  Добавить строку
                </Button>
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default OfferedDepositsTable;
